export default "__VITE_ASSET__1c99c24d__"